import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    informacionCliente: []

}

const ADD_OC_FC01 = 'ADD_OC_FC01'
const PUT_OC_FC01 = 'PUT_OC_FC01'
const GENERAR_CERTIFICADO_CUMPLIMIENTO_NOM = 'GENERAR_CERTIFICADO_CUMPLIMIENTO_NOM'
const ACTUALIZAR_CERTIFICADO_CUMPLIMIENTO_NOM = 'ACTUALIZAR_CERTIFICADO_CUMPLIMIENTO_NOM'
const GENERAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27 = 'GENERAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27'
const ACTUALIZAR_DATOS_CERTIFICADO_CUMPLIMIENTO_NOM = 'ACTUALIZAR_DATOS_CERTIFICADO_CUMPLIMIENTO_NOM'
const ACTUALIZAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27 = 'ACTUALIZAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27'
const ACTUALIZAR_DATOS_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27 = 'ACTUALIZAR_DATOS_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27'
const GENERAR_CONSTANCIA_FC_37 = 'GENERAR_CONSTANCIA_FC_37'
const ACTUALIZAR_CONSTANCIA_FC_37 = 'ACTUALIZAR_CONSTANCIA_FC_37'
const ACTUALIZAR_DATOS_CONSTANCIA_FC_37 = 'ACTUALIZAR_DATOS_CONSTANCIA_FC_37'
const ACTUALIZAR_ARCHIVO_OC_FC01_EXITO = 'ACTUALIZAR_ARCHIVO_OC_FC01_EXITO'
const ACEPTAR_SOLICITUD_FC01 = 'ACEPTAR_SOLICITUD_FC01'
const GET_INFORMACION_CLIENTE = 'GET_INFORMACION_CLIENTE'
const GENERAR_REVISION_EVALUACION_FC11 = 'GENERAR_REVISION_EVALUACION_FC11'
const ACTUALIZAR_CONSTANCIA_FC_11 = 'ACTUALIZAR_CONSTANCIA_FC_11'
export const ObtenerInformacionCliente = createAsyncThunk(
    GET_INFORMACION_CLIENTE,
    async (id) => {
        try {
            const fullUrl = host + `SolicitudFC01_OC/obtenerInformacionCliente/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const agregarFC01_OCAccion = createAsyncThunk(
    ADD_OC_FC01,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudFC01_OC/agregarNuevoFC01OC`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC01_OCAccion = createAsyncThunk(
    PUT_OC_FC01,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudFC01_OC/actualizarFC01OC`
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const generarCertificadoFC13 = createAsyncThunk(
    GENERAR_CERTIFICADO_CUMPLIMIENTO_NOM,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarCertificadoFC13`
            const fullUrlFormato = host + `SolicitudFC01_OC/agregarOCDatosFC_13`

            const res = await axios.post(fullUrlFormato, { data: data.dataForm })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarCertificadoFC13 = createAsyncThunk(
    ACTUALIZAR_CERTIFICADO_CUMPLIMIENTO_NOM,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarCertificadoFC13`
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_13`

            const res = await axios.put(fullUrlFormato, { data: data.dataForm })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarDatosCertificadoFC13 = createAsyncThunk(
    ACTUALIZAR_DATOS_CERTIFICADO_CUMPLIMIENTO_NOM,
    async (data) => {
        try {
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_13`

            const res = await axios.put(fullUrlFormato, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)


export const generarConstanciaFC27 = createAsyncThunk(
    GENERAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarConstanciaFC27`
            const fullUrlFormato = host + `SolicitudFC01_OC/agregarOCDatosFC_27`
            let data27 = {
                numeroconstancia: data?.numeroConstancia, categoriamezcal: data?.categoriamezcal,
                destinonacional: data?.checkDestinoNacional, destinoexportacion: data?.checkDestinoExportacion,
                norma1: data?.norma1, norma2: data?.norma2, norma3: data?.norma3, norma4: data?.norma4,
                autorizacionusohologramassi: data?.checkUsoDeHologramasSi, autorizacionusohologramasno: data?.checkUsoDeHologramasNo,
                embalaje: data?.embalajeCheck, folletostripticos: data?.folletosCheck, espectaculares: data?.espectacularesCheck,
                rotulado: data?.rotuladoCheck, facturas: data?.facturasCheck, paginasweb: data?.paginaCheck,
                otrodocumento: data?.documentoCheck, observacionesbeneficiario: data?.observacionesbeneficiario,
                idsolicitudesocfc01: data?.idsolicitudesocfc01, idestatuspdfoc: data?.idestatuspdfoc, fechaemision: data.fechaemisionC
            }
            const res = await axios.post(fullUrlFormato, { data: data27 })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarConstanciaFC27 = createAsyncThunk(
    ACTUALIZAR_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarConstanciaFC27`
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_27`
            let data27 = {
                numeroconstancia: data?.numeroConstancia, categoriamezcal: data?.categoriamezcal,
                destinonacional: data?.checkDestinoNacional, destinoexportacion: data?.checkDestinoExportacion,
                norma1: data?.norma1, norma2: data?.norma2, norma3: data?.norma3, norma4: data?.norma4,
                autorizacionusohologramassi: data?.checkUsoDeHologramasSi, autorizacionusohologramasno: data?.checkUsoDeHologramasNo,
                embalaje: data?.embalajeCheck, folletostripticos: data?.folletosCheck, espectaculares: data?.espectacularesCheck,
                rotulado: data?.rotuladoCheck, facturas: data?.facturasCheck, paginasweb: data?.paginaCheck,
                otrodocumento: data?.documentoCheck, observacionesbeneficiario: data?.observacionesbeneficiario,
                idsolicitudesocfc01: data?.idsolicitudesocfc01, idestatuspdfoc: data?.idestatuspdfoc,
                idsolicitudesocfc27: data?.idsolicitudesocfc27, fechaemision: data.fechaemisionC
            }
            const res = await axios.put(fullUrlFormato, { data: data27 })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarDatosConstanciaFC27 = createAsyncThunk(
    ACTUALIZAR_DATOS_CONSTANCIA_CUMPLIMIENTO_COMERCIALIZADORFC27,
    async (data) => {
        try {
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_27`

            const res = await axios.put(fullUrlFormato, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const generarConstanciaFC37 = createAsyncThunk(
    GENERAR_CONSTANCIA_FC_37,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarConstanciaFC37`
            const fullUrlFormato = host + `SolicitudFC01_OC/agregarOCDatosFC_37`
            let data37 = {
                numeroconstancia: data?.numeroConstancia, idsolicitudesocfc01: data.idsolicitudesocfc01
            }
            const res = await axios.post(fullUrlFormato, { data: data37 })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarConstanciaFC37 = createAsyncThunk(
    ACTUALIZAR_CONSTANCIA_FC_37,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarConstanciaFC37`
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_37`
            let data37 = {
                numeroconstancia: data?.numeroConstancia, idsolicitudesocfc37: data?.idsolicitudesocfc37
            }
            const res = await axios.put(fullUrlFormato, { data: data37 })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const generarConstanciaFC11 = createAsyncThunk(
    GENERAR_REVISION_EVALUACION_FC11,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarRevisionFC11`
            const fullUrlFormato = host + `SolicitudFC01_OC/agregarOCDatosFC_11`

            let data11 = {
                fecharevision: data.fecharevision,
                numerosolicitud: data.numerosolicitud,
                tipocertificado: data.tipoCertificado,

                especificaciones: data.apartado1,
                material: data?.apartado2,
                categorias: data?.apartado3,
                fisicoquimicas: data?.apartado4,
                proceso: data?.apartado5,
                clase: data?.apartado6,
                envasado: data?.apartado7,
                etiquetado: data?.apartado8,
                exportacion: data?.apartado9,
                comercializacion: data?.apartado10,
                evaluacion: data?.apartado11,
                numerocertificado: data.noCertificado,
                criterio: data.criterio,
                relativo: data?.Cumple,
                fechainiciovigencia: data?.fechaVigencia,
                fechavencimiento: data?.fechaVencimiento,
                idsolicitudesocfc01: data.idsolicitudesocfc01
            }
            const res = await axios.post(fullUrlFormato, { data: data11 })

            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarConstanciaFC11 = createAsyncThunk(
    ACTUALIZAR_CONSTANCIA_FC_11,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarRevisionFC11`
            const fullUrlFormato = host + `SolicitudFC01_OC/actualizarOCDatosFC_11`
            let data11 = {
                fecharevision: data.fecharevision,
                numerosolicitud: data.numerosolicitud,
                tipocertificado: data.tipoCertificado,

                especificaciones: data.apartado1,
                material: data?.apartado2,
                categorias: data?.apartado3,
                fisicoquimicas: data?.apartado4,
                proceso: data?.apartado5,
                clase: data?.apartado6,
                envasado: data?.apartado7,
                etiquetado: data?.apartado8,
                exportacion: data?.apartado9,
                comercializacion: data?.apartado10,
                evaluacion: data?.apartado11,
                numerocertificado: data.noCertificado,
                criterio: data.criterio,
                relativo: data?.Cumple,
                fechainiciovigencia: data?.fechaVigencia,
                fechavencimiento: data?.fechaVencimiento,
                idsolicitudesocfc11: data.idsolicitudesocfc11,
                idsolicitudesocfc01: data.idsolicitudesocfc01
            }
            const res = await axios.put(fullUrlFormato, { data: data11 })
            await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarFileOCFC_01 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_OC_FC01_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const AceptarSolicitudFC_01 = createAsyncThunk(
    ACEPTAR_SOLICITUD_FC01,
    async (data) => {
        try {
            const fullUrl = host + `FormatosRoutes/generarPlanServicios`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const metodosSolicitudFC01Slice = createSlice({

    name: 'metodosSolicitudFC01Slice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [ObtenerInformacionCliente.fulfilled]: (state, { payload }) => {
            state.informacionCliente = payload
        },
    },

})


export const { } = metodosSolicitudFC01Slice.actions
export const SolicitudesFC01_OCReducer = metodosSolicitudFC01Slice.reducer